// @flow
import * as React from 'react';
import interpolateComponents from 'interpolate-components';
import Box from 'components/Box';
import { H4, BodySmall } from 'components/Text';
// @HACK - Using PrimaryButtonLink instead of PrimaryButtonRouterLink due to issues w page not loading
import Button, { TrackedPrimaryButtonLink } from 'components/Button';
import Icon from 'components/Icon';
import TrackedLink from 'components/TrackedLink';
import ToggleHelperContainer from 'containers/ToggleHelperContainer';
import { colors } from '../theme';

const DaysLink = ({
  component,
  href,
  ...props
}: {
  component: React.ElementType,
  href: string
}) => (
  <Box
    component={component}
    href={href}
    eventName="Idealist Days Promo"
    {...props}
  />
);

const info = {
  GROUP: {
    headline: /* TRANSLATORS: Idealist days promo ad */ getText(
      'What are Mutual Aid Groups?'
    ),
    body: [
      <BodySmall>
        {interpolateComponents({
          mixedString: getText(
            `Mutual aid groups offer opportunities for communities to connect, 
            both virtually and in person, in order to support one another and 
            share resources in this time of crisis. Start connecting with others 
            near you by {{esLink}}searching for{{/esLink}} or {{link}}creating a group{{/link}} in your community.`
          ),
          components: {
            esLink:
              USER_LOCALE === 'es' ? (
                <DaysLink href="/es/mutualaid" component={TrackedLink} />
              ) : (
                <></>
              ),
            link: <DaysLink href="/groups/create" component={TrackedLink} />
          }
        })}
      </BodySmall>
    ]
  },
  IDEALIST_DAY_EVENT: {
    headline: /* TRANSLATORS: Idealist days promo ad */ getText(
      'What are Idealist Days?'
    ),
    body: [
      <BodySmall>
        {/* TRANSLATORS: Idealist days promo ad */ getText(
          'Idealist Days are monthly days of action and service on 3/3, 4/4, etc.'
        )}
      </BodySmall>,
      <BodySmall mt="0.5em">
        {/* TRANSLATORS: Idealist days promo ad */ getText(
          'Curious about setting up your own Idealist Day activity?'
        )}
      </BodySmall>,
      <DaysLink
        href={getText('/en/days/home')}
        component={TrackedPrimaryButtonLink}
        mt={24}
        mb={12}
      >
        {getText('Learn More')}
      </DaysLink>
    ]
  }
};

export default ({
  type,
  ...props
}: {
  type: 'GROUP' | 'IDEALIST_DAY_EVENT'
}) => (
  <Box p="20px 30px" bg={colors.offWhite} {...props}>
    <ToggleHelperContainer defaultValue={type === 'GROUP'}>
      {(open, toggle) => (
        <>
          <Button onClick={toggle} width="100%">
            <Box
              position="relative"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              width="100%"
            >
              <H4 m="0">{info[type].headline}</H4>
              <Box
                width="15px"
                height="9px"
                transform={open ? 'rotate(180deg)' : undefined}
              >
                <Icon name="chevron" display="block" />
              </Box>
            </Box>
          </Button>
          {open && (
            <Box mt="12px" pr="20px">
              {info[type].body.map((body, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <React.Fragment key={index}>{body}</React.Fragment>
              ))}
            </Box>
          )}
        </>
      )}
    </ToggleHelperContainer>
  </Box>
);
